<script setup lang="ts">
import { inject, onMounted, ref } from 'vue';
import ClubAccessSettings from '../../js/dto/club/ClubAccessSettings.js';
import ClubRepository from '../../js/repository/ClubRepository.js';
import Error from '../../js/model/Error.js';
import KgrAccessSettingsForm from '../../components/club/settings/AccessSettingsForm.vue';
import KgrFormScaffold from '../../components/common/form/FormScaffold.vue';
import KgrLoading from '../../components/common/Loading.vue';
import type { Notify } from '@/composables/notifications';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    clubId: number;
}>();

const notify = inject<Notify>('notify')!;
const loading = ref(true);
const pending = ref(false);
const error = ref(new Error());
const accessSettings = ref<ClubAccessSettings | null>(null);

onMounted(() => {
    load();
});

function load() {
    ClubRepository.getAccessSettings(props.clubId)
        .then(response => accessSettings.value = response)
        .catch(err => {
            error.value = err;
            notify.error('error.loadingData');
        })
        .finally(() => loading.value = false);
}

function updateSettings() {
    pending.value = true;
    ClubRepository.updateAccessSettings(props.clubId, accessSettings.value)
        .then(() => {
            error.value = new Error();
            notify.success('saveChanges.success');
            pending.value = false;
            load();
        })
        .catch(err => {
            error.value = err;
            notify.error('saveChanges.error');
            pending.value = false;
        });
}
</script>

<template>
    <kgr-form-scaffold
        :pending="loading || pending"
        :with-back-button="false"
        @primaryBtnClicked="updateSettings"
    >
        <kgr-loading v-if="loading" />
        <div class="kgr-row" v-else-if="accessSettings">
            <kgr-access-settings-form
                v-model:access-settings="accessSettings"
                :error="error"
                class="animated fadeIn"
            />
        </div>
    </kgr-form-scaffold>
</template>

<style scoped lang="scss" rel="stylesheet/scss"></style>
